<template>
	<div class="contact-us">
		<div class="d-flex">
			<div @click="collapse = !collapse" class="contact-us__box">
				<img :src="commentIcon" alt="" width="35" height="30">
			</div>
			<Transition name="fade">
				<div v-if="collapse" class="contact-us__body">
					<p class="contact-us__headline">Kérdése van?</p>
					<p class="contact-us__subline">Írjon nekünk és csapatunk hamarosan válaszol</p>

					<input-unit
							v-model="name"
							:options="{
								type: 'text',
								slug: 'name',
								class: 'contact-us__input',
								placeholder: 'Név'
							}
					"/>
					<input-unit
							v-model="email"
							:options="{
									type: 'text',
									slug: 'E-mail cím',
									class: 'contact-us__input',
									placeholder: 'E-mail cím',

							}
					"/>

					<textarea-unit
							v-model="text"
							:options="{
								class: 'contact-us__input contact-us__input--textarea',
								placeholder: 'Üzenet szövege'
							}"
					/>

					<honeypot-field v-model="honeypot"/>
					<privacy-notice/>

					<button-unit
							class="contact-us__btn"
							@click-on-btn="sendToEmail"
							:options="{
								text: 'Üzenet küldése',
								bgColor: '#F7F9EE',
								textColor: '#32341D',
							}"
					/>
				</div>
			</Transition>
		</div>
	</div>
</template>


<script setup lang="ts">
import commentIcon from "@Images/comment.svg";
import InputUnit from "@/WebApp/Components/Units/InputUnit.vue";
import {ref} from "vue";
import TextareaUnit from "@/WebApp/Components/Units/TextareaUnit.vue";
import ButtonUnit from "@/WebApp/Components/Units/ButtonUnit.vue";
import HoneypotField from "@/WebApp/Components/Units/HoneypotField.vue";
import PrivacyNotice from "@/WebApp/Components/Units/PrivacyNotice.vue";
import {formErrorMessage, protectionPayload} from "@/WebApp/Utils/FormProtection";
import axios from "axios";
import {customErrorAlert, customSuccessAlert} from "@WebAppComposable/SweetAlertComposable";

const name: string = ref('');
const email: string = ref('');
const text: string = ref('');
const honeypot = ref('');

const collapse: boolean = ref(false);

const sendToEmail = (async () => {

	if (email.value.length === 0 || name.value.length === 0 || text.value.length === 0) {
		customErrorAlert('Minden mezőt kikell tölteni!');
		return;
	}

	const protection = await protectionPayload(honeypot.value, 'contact_us');
	axios.post('/api/contact-us', {
		name: name.value,
		email: email.value,
		text: text.value,
		...protection
	}).then((response: any) => {
		if (response.status === 200 && response.data.success === true) {
			customSuccessAlert('Hamarosan keresni fogjuk!', '');
		}
	}).catch((error: any) => {
		customErrorAlert('Valami hiba történt', formErrorMessage(error, error.response?.data?.message ?? ''));
	})
});

</script>
<style scoped>

</style>
